export function handleSwiperGalleryTurbolinks() {
  document.addEventListener('turbolinks:load', () => {
    // メインスライダーとサムネイルスライダーのペアを初期化
    const mainSwipers = document.querySelectorAll('.swiper-container.main-swiper');
    mainSwipers.forEach((mainSwiperElement) => {
      const thumbSwiperElement = mainSwiperElement.closest('.container')?.querySelector('.swiper-container.thumb-swiper');
      if (!thumbSwiperElement) return;

      const thumbsSwiper = new Swiper(thumbSwiperElement, {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: false,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          500: {
            slidesPerView: 4,
          },
          900: {
            slidesPerView: 6,
          },
        },
      });

      const mainSwiper = new Swiper(mainSwiperElement, {
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: mainSwiperElement.querySelector('.swiper-button-next'),
          prevEl: mainSwiperElement.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: mainSwiperElement.querySelector('.swiper-pagination'),
          clickable: true,
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
      });

      // 画像読み込み後に更新
      const images = mainSwiperElement.querySelectorAll('img');
      const totalImages = images.length;
      let loadedCount = 0;

      function checkAllImagesLoaded() {
        loadedCount++;
        if (loadedCount === totalImages) {
          mainSwiper.update();
          thumbsSwiper.update();
        }
      }

      if (totalImages === 0) {
        // 画像がない場合は即更新
        mainSwiper.update();
        thumbsSwiper.update();
      } else {
        images.forEach((img) => {
          if (img.complete) {
            checkAllImagesLoaded();
          } else {
            img.addEventListener('load', checkAllImagesLoaded);
            img.addEventListener('error', checkAllImagesLoaded);
          }
        });
      }
    });
  });

  // turbolinks:renderでupdate()のみ行う
  document.addEventListener('turbolinks:render', () => {
    requestAnimationFrame(() => {
      const swipers = document.querySelectorAll('.swiper-container');
      swipers.forEach((swiperEl) => {
        if (swiperEl.swiper) {
          swiperEl.swiper.update();
        }
      });
    });
  });
}
